module.exports = __webpack_public_path__ + "static/media/event_banner_default98abe1eae0ce368b61b9ef52288f4254.webp";